import { render, staticRenderFns } from "./doris-conf-detail.vue?vue&type=template&id=cbd1ff96&scoped=true&"
import script from "./doris-conf-detail.vue?vue&type=script&lang=ts&"
export * from "./doris-conf-detail.vue?vue&type=script&lang=ts&"
import style0 from "./doris-conf-detail.vue?vue&type=style&index=0&id=cbd1ff96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd1ff96",
  null
  
)

export default component.exports